import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAtom } from 'jotai'
import { activeWorkspaceWithStorageAtom } from '@/stores/workspaceStore'
import { SidebarProvider } from '@deepguide-ai/ui/sidebar'
import { AppSidebar } from '@/components/app-sidebar'
import { APP_NAME } from '@/lib/env'
import { useOrganizationPermissions } from '@/hooks/useOrganizationPermissions'
export const Route = createFileRoute('/(protected)/')({
  component: HomeEntry,
  validateSearch: (
    search: Record<string, unknown>
  ): { token?: string; expiry?: string } => {
    // Handle native login tokens
    const { token, expiry } = search
    if (token && expiry) {
      console.log('setting token and expiry', token, expiry)
      localStorage.setItem('auth:token', token as string)
      localStorage.setItem('auth:expiry', expiry as string)
    }
    return {
      token: search?.token as string,
      expiry: search.expiry as string,
    }
  },
})

function HomeEntry() {
  const isUndelegatedPartner = Route.useRouteContext({
    select: ({ organization, session }) =>
      !!organization?.isPartner &&
      !(session.session as { delegatedOrganizationId?: string }).delegatedOrganizationId,
  })

  return isUndelegatedPartner ? <PartnerEntry /> : <RouteComponent />
}

function PartnerEntry() {
  const organizationId = Route.useRouteContext({
    select: ({ organization }) => organization?.id,
  })
  const { isAdmin, isLoading } = useOrganizationPermissions(organizationId)

  if (isLoading) {
    return null
  }

  if (isAdmin) {
    return <Navigate to='/partner' replace />
  }

  return <RouteComponent />
}

function RouteComponent() {
  const [activeWorkspace] = useAtom(activeWorkspaceWithStorageAtom)

  if (activeWorkspace) {
    // Redirect to workspace root — the $workspaceId/index.tsx beforeLoad
    // handles role-based routing (auditor → auditor-center, etc.)
    return <Navigate to={`/workspaces/${activeWorkspace.id}` as any} replace />
  }

  // Handle case when no workspace is active
  return (
    <SidebarProvider>
      <div className="flex h-screen">
        <AppSidebar />
        <main className="flex-1 overflow-hidden">
          <div className="h-full w-full bg-background">
            <div className="flex items-center justify-center h-full">
              <div className="text-center">
                <h2 className="text-2xl font-bold mb-2">Welcome to {APP_NAME}</h2>
                <p className="text-muted-foreground">Select or create a workspace to get started</p>
              </div>
            </div>
          </div>
        </main>
      </div>
    </SidebarProvider>
  )
}
